(function() {
  if (window.location.search.indexOf('adjust') === -1) return;

  var cans = document.querySelectorAll('.latas-can-img');
  if (!cans.length) return;

  var style = document.createElement('style');
  style.textContent = [
    '.dbg-can-wrap {',
    '  position: relative; cursor: grab; user-select: none;',
    '  outline: 2px dashed #ff0; outline-offset: 2px;',
    '  display: inline-block;',
    '}',
    '.dbg-can-handle {',
    '  position: absolute; width: 22px; height: 22px;',
    '  background: #ff0; border: 3px solid #000;',
    '  z-index: 10002; box-shadow: 0 0 8px rgba(0,0,0,0.6);',
    '}',
    '.dbg-can-handle-br { bottom: -11px; right: -11px; cursor: nwse-resize; }',
    '.dbg-can-label {',
    '  position: absolute; bottom: 100%; left: 50%; transform: translateX(-50%);',
    '  margin-bottom: 8px;',
    '  font: bold 11px monospace; color: #ff0; background: rgba(0,0,0,0.85);',
    '  padding: 3px 8px; border-radius: 4px; white-space: nowrap;',
    '  pointer-events: none; z-index: 10002;',
    '}',
  ].join('\n');
  document.head.appendChild(style);

  var wraps = [];

  cans.forEach(function(img) {
    var div = document.createElement('div');
    div.className = 'dbg-can-wrap';
    img.parentNode.insertBefore(div, img);
    div.appendChild(img);
    img.style.width = '100%';
    img.style.display = 'block';
    img.style.position = 'relative';

    var handle = document.createElement('div');
    handle.className = 'dbg-can-handle dbg-can-handle-br';
    div.appendChild(handle);

    var label = document.createElement('div');
    label.className = 'dbg-can-label';
    div.appendChild(label);

    wraps.push({ div: div, img: img });

    // Drag
    var dragging = false, resizing = false, startData = {};

    div.addEventListener('mousedown', function(e) {
      if (e.target.classList.contains('dbg-can-handle')) return;
      e.preventDefault();
      dragging = true;
      div.style.cursor = 'grabbing';
      startData = { mx: e.clientX, my: e.clientY, ml: parseInt(img.style.marginLeft||0), mt: parseInt(img.style.marginTop||0) };
    });

    handle.addEventListener('mousedown', function(e) {
      e.preventDefault();
      e.stopPropagation();
      resizing = true;
      startData = { mx: e.clientX, w: div.getBoundingClientRect().width };
    });

    document.addEventListener('mousemove', function(e) {
      if (dragging) {
        var dx = e.clientX - startData.mx;
        var dy = e.clientY - startData.my;
        img.style.marginLeft = (startData.ml + dx) + 'px';
        img.style.marginTop = (startData.mt + dy) + 'px';
        updateLabel(div, img);
      }
      if (resizing) {
        var dx = e.clientX - startData.mx;
        var newW = startData.w + dx;
        if (newW < 50) newW = 50;
        div.style.width = newW + 'px';
        img.style.maxWidth = 'none';
        updateLabel(div, img);
      }
    });

    document.addEventListener('mouseup', function() {
      if (dragging) div.style.cursor = 'grab';
      dragging = false;
      resizing = false;
    });
  });

  function updateLabel(div, img) {
    var label = div.querySelector('.dbg-can-label');
    var w = Math.round(div.getBoundingClientRect().width);
    var ml = parseInt(img.style.marginLeft || 0);
    var mt = parseInt(img.style.marginTop || 0);
    label.textContent = 'W:' + w + 'px ML:' + ml + ' MT:' + mt;
  }

  setTimeout(function() {
    wraps.forEach(function(w) { updateLabel(w.div, w.img); });
  }, 500);
})();
